(function () {
  window.addEventListener("DOMContentLoaded", (event) => {
    
    let cart_products = document.querySelector("#CartPageForm"),
        header_cart   = document.querySelector(".cart__drawer-form");
    
    if (cart_products) {
      const config = { childList: true, subtree: true };
      
      // Callback function to execute when mutations are observed
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.target.innerText.includes("DKK") && mutation.target.innerText.includes(",")) {
            mutation.target.childNodes.forEach(child => {
              if (child.data == undefined) {
                if (child.childNodes.length == 1) {
                  let price = child.innerText.split(',')
                  child.innerHTML = price[0] + "<sup>" + price[1] + "</sup>"
                }
              } else {
                if (child.data.includes("DKK")) {
                  let price = child.data.split(',')
                  mutation.target.innerHTML = price[0] + "<sup>" + price[1] + "</sup>"
                }
              }
            })
          }
        }
      };
      
      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);
      
      // Start observing the target node for configured mutations
      observer.observe(cart_products, config);
    }

    if (header_cart) {
      const config = { childList: true, subtree: true };
      
      // Callback function to execute when mutations are observed
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.target.innerText.includes("DKK") && mutation.target.innerText.includes(",")) {
            mutation.target.childNodes.forEach(child => {
              if (child.data == undefined) {
                if (child.childNodes.length == 1) {
                  let price = child.innerText.split(',')
                  child.innerHTML = price[0] + "<sup>" + price[1] + "</sup>"
                }
              } else {
                if (child.data.includes("DKK")) {
                  let price = child.data.split(',')
                  mutation.target.innerHTML = price[0] + "<sup>" + price[1] + "</sup>"
                }
              }
            })
          }
        }
      };
      
      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);
      
      // Start observing the target node for configured mutations
      observer.observe(header_cart, config);
    }
    
  });
})()
class TermsAndConditions extends HTMLElement {
    constructor() {
        super();      
      	this.Binds();
    }
  
    Binds () {
      var self = this;
      console.log( this.parentNode.querySelector('.cart__checkout--fake-2'))
      this.parentNode.querySelector('.cart__checkout--fake-2').addEventListener("click", function (event) {
        if (!this.querySelector('#enable_terms').checked) {
          event.preventDefault(); 
          
          var container = this.querySelector('#enable_terms');
          
          if (container.querySelector('.error') == null) {
            var error = document.createElement('p');
            error.classList.add('error');
            error.innerHTML = "Dette felt er påkrævet";
            container.appendChild(error);
            
            if (!self.is_terms_bound) {
              this.querySelector('#enable_terms').addEventListener('change', function () {
                if (container.querySelector('.error')) {
                  container.querySelector('.error').parentNode.removeChild(container.querySelector('.error'));
                }
              }, true);
              self.is_terms_bound = true;
            }
          }
        } 
      });
    }
}

customElements.define("terms-and-conditions", TermsAndConditions);


